import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class LoadingScreenService {
  loading = signal<boolean>(false);

  startLoading() {
    this.loading.set(true);
  }

  stopLoading() {
    this.loading.set(false);
  }

}
